import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/contexts/CartContext";

type Props = {
  className?: string;
};

const CartIcon = ({ className = "" }: Props) => {
  const { openCart, itemCount } = useCart();
  return (
    <Button
      type="button"
      onClick={openCart}
      size="icon"
      variant="outline"
      aria-label={`Open cart (${itemCount} items)`}
      className={`relative h-10 w-10 rounded-full border-primary/35 bg-background/50 ${className}`}
    >
      <ShoppingCart className="h-4 w-4" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center">
          {itemCount > 99 ? "99+" : itemCount}
        </span>
      )}
    </Button>
  );
};

export default CartIcon;
